import { render, staticRenderFns } from "./AppDescriptionCard.vue?vue&type=template&id=6331912c&"
import script from "./AppDescriptionCard.vue?vue&type=script&lang=js&"
export * from "./AppDescriptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports